import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const invoicesState = (state: AppState) => state.invoices;

export const latestExportSelector = createSelector(invoicesState, state => state.latestExport);
